import { Text } from '@react-three/drei';
import { T } from 'components/common/text';
import React from 'react';
import { useProjectFileStore } from 'store/local/projectFile';

interface ProjectModelViewerErrorBoundaryProps {
  children: React.ReactNode;
  onError?: (error: Error) => void;
}

interface ProjectModelViewerErrorBoundaryState {
  hasError: boolean;
}

export default class ProjectModelViewerErrorBoundary extends React.Component<
  ProjectModelViewerErrorBoundaryProps,
  ProjectModelViewerErrorBoundaryState
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.props.onError?.(error);
    console.error('Model Viewer Error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Text color="red" fontSize={5} position={[1, 0, 1]}>
          MODEL_LOADER_ERROR
        </Text>
      );
    }

    return this.props.children;
  }
}
